<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="12">
            <a-form-item label="渠道">
              <a-select
                placeholder="请选择渠道"
                v-model="queryParam.channelCode"
              >
                <a-select-option
                  v-for="item in channelList"
                  :key="item.id"
                  :value="item.code"
                >
                  {{ item.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="8">
            <span
              style="float: left; overflow: hidden"
              class="table-page-search-submitButtons"
            >
              <a-button type="primary" @click="searchQuery" icon="search"
                >查询</a-button
              >
              <a-button
                type="primary"
                @click="searchReset"
                icon="reload"
                style="margin-left: 8px"
                >重置</a-button
              >
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">新增</a-button>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"
            ><a-icon type="delete" />批量删除</a-menu-item
          >
        </a-menu>
        <a-button style="margin-left: 8px">
          批量操作 <a-icon type="down"
        /></a-button>
      </a-dropdown>
    </div>

    <!-- table区域-begin -->
    <div>
      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择
        <a style="font-weight: 600">{{ selectedRowKeys.length }}</a
        >项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>

      <a-table
        :columns="columns"
        :scroll="{ x: 1500 }"
        size="middle"
        :pagination="ipagination"
        bordered
        :dataSource="dataSource"
        :loading="loading"
        rowKey="id"
        :rowSelection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange,
        }"
        @change="handleTableChange"
      >
        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <a-menu-item v-show="record.level < 7">
                <a href="javascript:;" @click="handleAddSub(record)"
                  >添加下级</a
                >
              </a-menu-item>
              <a-menu-item>
                <a @click="handleDelete(record.id)">删除</a>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

        <span slot="channelCode_dict" slot-scope="text, record">
          {{ handleChannelName(record.channelCode) }}
        </span>
      </a-table>
    </div>

    <contentColumn-modal
      ref="modalForm"
      @ok="modalFormOk"
      :channelList="channelList"
      :dataSource="dataSource"
    ></contentColumn-modal>
  </a-card>
</template>

<script>
import { getAction, postAction } from '@/api/manage';
import '@/assets/less/TableExpand.less';
import { mixinDevice } from '@/utils/mixin';
import JInput from '@/components/jeecg/JInput';
import { filterObj } from '@/utils/util';
import ContentColumnModal from './modules/ContentColumnModal';

export default {
  name: 'ContentColumnList',
  mixins: [mixinDevice],
  components: {
    JInput,
    ContentColumnModal,
  },
  data() {
    return {
      description: '渠道栏目管理页面',
      channelList: [],
      loading: false,
      // queryParam: {},
      selectedRowKeys: [],
      selectionRows: [],
      dataSource: [],
      queryParam: {},
      channelCodeValue: '',
      ipagination: {
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showTotal: (total, range) => {
          return range[0] + '-' + range[1] + ' 共' + total + '条';
        },
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0,
      },
      // 表头
      columns: [
        {
          title: '栏目名字',
          width: 300,
          dataIndex: 'name',
        },
        {
          title: '栏目代码',
          align: 'center',
          dataIndex: 'code',
        },
        {
          title: '栏目层级',
          align: 'center',
          dataIndex: 'level',
        },
        {
          title: '跳转链接',
          align: 'center',
          dataIndex: 'url',
        },
        {
          title: '所属渠道',
          align: 'center',
          dataIndex: 'channelCode',
          scopedSlots: { customRender: 'channelCode_dict' },
        },
        {
          title: '排序',
          align: 'center',
          dataIndex: 'sort',
        },
        {
          title: '创建时间',
          align: 'center',
          dataIndex: 'createTime',
          customRender: function (text) {
            return !text ? '' : text.length > 10 ? text.substr(0, 10) : text;
          },
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          width: 147,
          fixed: 'right',
          scopedSlots: { customRender: 'action' },
        },
      ],
      url: {
        list:
          process.env.VUE_APP_CMS_CONTENT + '/content/column/queryByChannel',
        delete: process.env.VUE_APP_CMS_CONTENT + '/content/column/delete',
        deleteBatch:
          process.env.VUE_APP_CMS_CONTENT + '/content/column/deleteBatch',
        exportXlsUrl:
          process.env.VUE_APP_CMS_CONTENT + '/content/column/exportXls',
        channelList: process.env.VUE_APP_CMS_SYSTEM + '/sys/channel/list',
      },
      dictOptions: {},
    };
  },
  computed: {},
  created() {
    this.getList();
    this.initDictConfig();
  },
  methods: {
    handleChannelName(code) {
      let target = this.channelList.find((item) => item.code == code);
      return target ? target.name : '--';
    },
    initDictConfig() {
      let param = {
        pageNo: '',
        pageSize: 10000000,
      };
      getAction(this.url.channelList, param).then((res) => {
        if (res.success) {
          this.channelList =
            res.result && res.result.records ? res.result.records : [];
        } else {
          this.$message.warning(res.message);
        }
      });
    },
    // 获取点中时的数据
    onSelectChange(selectedRowKeys, selectionRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectionRows = selectionRows;
    },
    // 查询
    getList(arg) {
      let that = this;
      if (arg === 1) {
        that.ipagination.current = 1;
      }
      let params = this.getQueryParams();
      // params.channelCode = 'pc_service';
      if (this.queryParam.channelCode) {
        params.channelCode = this.queryParam.channelCode;
      } else {
        params.channelCode = "";
      } 
      // console.log(params, params.channelCode);
      getAction(that.url.list, params)
        .then((res) => {
          that.loading = true;
          if (res.success) {
            that.dataSource = res.result;
            that.loading = false;
          }
        })
        .finally(() => {
          that.loading = false;
        });
    },
    //添加
    handleAdd() {
      this.$refs.modalForm.add();
      this.$refs.modalForm.title = '新增';
      this.$refs.modalForm.disableSubmit = false;
    },
    //获取查询条件
    getQueryParams() {
      let sqp = {};
      let param = Object.assign(sqp, this.queryParam);
      let channelCodeValue = param.channelCode;
      console.log(channelCodeValue, '>>>>>', param);
      sessionStorage.setItem('channelCodeValue', channelCodeValue);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    // 编辑
    handleEdit(record) {
      console.log(record);
      this.$refs.modalForm.edit(record);
      this.$refs.modalForm.title = '编辑';
      this.$refs.modalForm.disableSubmit = false;
    },
    getQueryField() {
      var str = 'id,';
      this.columns.forEach(function (value) {
        str += ',' + value.dataIndex;
      });
      return str;
    },
    // 批量删除
    batchDel() {
      if (!this.url.deleteBatch) {
        this.$message.error('请设置url.deleteBatch属性!');
        return;
      }
      if (this.selectedRowKeys.length <= 0) {
        this.$message.warning('请选择一条记录！');
        return;
      } else {
        var ids = '';
        for (var a = 0; a < this.selectedRowKeys.length; a++) {
          ids += this.selectedRowKeys[a] + ',';
        }
        var that = this;
        this.$confirm({
          title: '确认删除',
          content: '是否删除选中数据?',
          onOk: function () {
            that.loading = true;
            postAction(that.url.deleteBatch, { ids: ids })
              .then((res) => {
                if (res.success) {
                  that.$message.success(res.message);
                  that.getList();
                  that.onClearSelected();
                } else {
                  that.$message.warning(res.message);
                }
              })
              .finally(() => {
                that.loading = false;
              });
          },
        });
      }
    },
    modalFormOk() {
      // 新增/修改 成功时，重载列表
      this.getList();
    },
    //删除
    handleDelete(id) {
      let that = this;
      console.log(1);
      that.$confirm({
        title: '确认删除',
        content: '确定要删除吗',
        onOk: function () {
          that.loading = true;
          postAction(that.url.delete, { id: id })
            .then((res) => {
              if (res.success) {
                that.getList(1);
                that.$message.success(res.message);
              } else {
                that.$message.error(res.message);
              }
            })
            .finally(() => {
              that.loading = false;
            });
        },
      });
    },
    searchQuery() {
      this.getList(1);
    },
    //重置
    searchReset() {
      this.queryParam = {};
      this.getList(1);
      // if (this.$route.query.type != 4) {
      //   this.getList(1);
      // }
    },
    onClearSelected() {
      this.selectedRowKeys = [];
      this.selectionRows = [];
    },
    //分页
    handleTableChange(pagination, filters, sorter) {
      console.log(1);
      this.onClearSelected(); //分页切换时清空表格选中
      //分页、排序、筛选变化时触发
      this.ipagination = pagination;
      this.getList();
    },
    handleAddSub(record) {
      this.$refs.modalForm.title = '添加子栏目';
      this.$refs.modalForm.localMenuType = 1;
      this.$refs.modalForm.disableSubmit = false;
      this.$refs.modalForm.currentLevel = record.level + 1;
      this.$refs.modalForm.edit({
        route: true,
        parentId: record.id,
        channelCode: record.channelCode,
      });
    },
  },
};
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
